<template>
    <table class="table table-striped table-bordered">
        <thead>
        <tr>
            <th scope="col">#</th>
            <th scope="col">Status</th>
            <th scope="col">Client</th>
            <!-- <th scope="col">Email</th> -->
            <th scope="col">Program</th>
            <th scope="col">Block</th>
            <th scope="col">Created</th>
            <th scope="col">Started</th>
            <th scope="col">Coach</th>
            <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(plan, index) in plans" v-bind:key="index">
            <td scope="row">{{ plan.id }}</td>
            <td scope="row"><plan-status-badge-component :status="plan.status"></plan-status-badge-component></td>
            <td>
                <a :href="'/coach/clients/'+plan.client.id">{{ plan.client.first_name }} {{ plan.client.last_name }}</a>
                <br>
                <small><a :href="'mailto:'+plan.client.email">{{ plan.client.email }}</a></small>
            </td>
            <!-- <td><a :href="'mailto:'+plan.client.email">{{ plan.client.email }}</a></td> -->
            <td>{{ plan.program.name }}</td>
            <td>{{ plan.plan_index }}</td>
            <td>{{ plan.created_at | moment("from", "now") }}</td>
            <td>{{ plan.start_date | moment("from", "now") }}</td>
            <!-- <td>{{ plan.created_at | moment("M/DD/YYYY hh:mm a") }}</td> -->
            <!-- <td>{{ plan.start_date | moment("M/DD/YYYY hh:mm a") }}</td> -->
            <td>
                <span v-if="plan.assigned_coach_id">{{ plan.assigned_coach.first_name }} {{ plan.assigned_coach.last_name }}</span>
                <span v-if="!plan.assigned_coach_id"></span>
            </td>
            <td>
                <a :href="'/coach/plans/'+plan.id" class="btn btn-secondary btn-sm">View</a>
                <!-- <button v-if="!plan.assigned_coach_id" class="btn btn-warning btn-sm">Claim</button> -->
            </td>
        </tr>
        <tr v-if="plans.length == 0">
            <td colspan="9">
                No plans yet.  :'(
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    export default {
        data() {
            return {
                // plans: []
                // plans: this.plans,
            }
        },
        computed: {
        },
        methods: {
        },
        props: [
            'plans'
        ],
        filters: {
        }
    }
</script>
<style></style>
